import { AfterViewInit, Directive, ElementRef, Input, inject } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
  selector: '[matTooltipOnTruncated]',
})
export class MatTooltipOnTruncatedDirective extends MatTooltip implements AfterViewInit {
  @Input('matTooltipOnTruncated')
  get message(): string {
    return super.message;
  }
  set message(value: string) {
    super.message = value;
  }
  private elementRef = inject(ElementRef<HTMLElement>);
  private truncateElem: Element;
  ngAfterViewInit(): void {
    let elem: Element = this.elementRef.nativeElement;
      // If it's on a mat-option, need the mat-option-text span within it
    if (elem.nodeName?.toUpperCase() === 'MAT-OPTION') {
      // children isn't an array and doesn't have an iterator
      // eslint-disable-next-line @typescript-eslint/prefer-for-of
      for (let i = 0; i < elem.children.length; i++) {
        if (elem.children[i].classList.contains('mat-option-text')) {
          elem = elem.children[i];
        }
      }
    }
    this.truncateElem = elem;
    super.ngAfterViewInit();
  }

  get disabled(): boolean {
    return super.disabled || (
      !!this.truncateElem &&
      this.truncateElem.scrollWidth <= this.truncateElem.clientWidth
    );
  }
  set disabled(value: boolean) {
    super.disabled = value;
  }
}
